import { createStore } from "vuex";
import authData from "./auth/index.js";
import userData from "./user_data/index.js";
import adminData from "./admin_data/index.js";
import appDefault from "./app_default/index.js";
import billingData from "./billing/index.js";
import contentManagement from "./content/index.js";
import challengesManagement from "./challenges/index.js";
import trainingManagement from "./training/index.js";
import meetingsManagement from "./meetings/index.js";
import rewardsManagement from "./rewards/index.js";
import newsfeedManagement from "./newsfeed/index.js";
import eventsManagement from "./events/index.js";
import formsManagement from "./forms/index.js";
import recruitmentManagement from "./recruitment/index.js";
import onboardingManagement from "./onboarding/index.js";
import goalPostsManagement from "./goal_posts/index.js";
import integrationManagement from "./integrations/index.js";

import VuexPersistence from "vuex-persist";

// Modules kept OUT of localStorage.
//
// A prospect record holds the personal data of someone who is not a platform
// user and has accepted no terms — date of birth, phone number, referees and
// their contact details, and whether a police check has been done. localStorage
// is plaintext, shared by everyone who uses the browser profile, and survives
// sign-out, so persisting that would outlive both the session and the user's
// relationship with the company (NFR-2). The board refetches on mount instead;
// the cost is one request, which is the right trade for this data.
const PERSIST_EXCLUDED = ["onboardingManagement"];

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) =>
    Object.fromEntries(
      Object.entries(state).filter(
        ([moduleName]) => !PERSIST_EXCLUDED.includes(moduleName),
      ),
    ),
});

const store = createStore({
  modules: {
    authData: authData,
    userData: userData,
    adminData: adminData,
    appDefault: appDefault,
    billingData: billingData,
    contentManagement: contentManagement,
    challengesManagement: challengesManagement,
    trainingManagement: trainingManagement,
    meetingsManagement: meetingsManagement,
    rewardsManagement: rewardsManagement,
    newsfeedManagement: newsfeedManagement,
    goalPostsManagement: goalPostsManagement,
    integrationManagement: integrationManagement,
    eventsManagement: eventsManagement,
    formsManagement: formsManagement,
    recruitmentManagement: recruitmentManagement,
    onboardingManagement: onboardingManagement,
  },
  plugins: [vuexLocal.plugin],
});

export default store;
